import { globalErrorResponse } from '../../shared/notification/actions';
import { shopPrefix } from '../../config';
import fileDownload from 'react-file-download';
import { http } from '../axios';

export function useDownloadCsv() {
    return () => {
        return http
            .get(`${shopPrefix}/v1/shoppingcart/download`)
            .then(response => {
                fileDownload(response.data, 'cart.csv');
            })
            .catch(error => globalErrorResponse(error));
    };
}
